import React, { FC } from 'react';
import { startCase } from 'lodash';

import EventTypeIcon from 'components/events/common/EventTypeIcon';

import { useEvent } from 'components/context/EventContext';

import { EventType } from 'types/enums';

import useStyles from '../Location/style';

const TypeInfo: FC = () => {
  const classes = useStyles();

  const { event } = useEvent();

  return !!event ? (
    <div className={classes.location}>
      <EventTypeIcon type={event.type as EventType} />
      <span className="name">{startCase(event.type)}</span>
    </div>
  ) : null;
};

export default TypeInfo;
